$('.customize-dropdown').selectmenu({
  change(event, data) {
    const selectedVal = data.item.label;
    if (selectedVal === 'Select') {
      $(
        '.custom-select-dropdown .ui-selectmenu-button .ui-selectmenu-text'
      ).addClass('placeholderText');
    } else {
      $(
        '.custom-select-dropdown .ui-selectmenu-button .ui-selectmenu-text'
      ).addClass('activeText');
    }
  },
  open() {
    $('div.ui-selectmenu-menu').each(function() {
      $(this).addClass('custom-select-field');
    });
  }
});
